import React from 'react';
import * as Styled from './StylovyzeDialog.styles';
import { Dialog, DialogTitle, } from '@mui/material';
import { Button } from '@innovyze/stylovyze/lib/components/Button';
/**
 * Styled dialog with title (optional), content and actions
 */
export const StylovyzeDialog = ({ onCancel, onConfirm, onSecondaryConfirm, open, title, titleId, content, children, confirmText, secondaryConfirmText, cancelText, dividers = 'title', cancelButtonProps = {}, confirmButtonProps = {}, secondaryConfirmButtonProps = {}, dialogProps = {}, dialogTitleProps = {}, otherActions, dataCy, onDialogClose, }) => {
    const dialogContent = children ?? content;
    const cancelButton = (React.createElement(Button, { variant: "contained", color: "secondary", onClick: onCancel, ...cancelButtonProps }, cancelText));
    const secondaryConfirmButton = secondaryConfirmText && (React.createElement(Button, { variant: "outlined", onClick: onSecondaryConfirm, color: "error", ...secondaryConfirmButtonProps }, secondaryConfirmText));
    const confirmButton = confirmText && (React.createElement(Button, { variant: "contained", onClick: onConfirm, color: "primary", ...confirmButtonProps }, confirmText));
    const otherActionButtons = otherActions &&
        otherActions.map(({ text, onClick, props }, i) => (React.createElement(Styled.ActionButton, { key: i, onClick: onClick, ...props }, text)));
    return (React.createElement(Dialog, { onClose: onDialogClose ?? onCancel, "data-cy": dataCy, open: open, "aria-labelledby": titleId, PaperProps: {
            square: true,
        }, ...dialogProps },
        title && (React.createElement(DialogTitle, { id: titleId, ...dialogTitleProps }, title)),
        React.createElement(Styled.DialogContent, { "$topDivider": dividers === 'title' || dividers === 'both', "$bottomDivider": dividers === 'both' }, dialogContent),
        otherActions && otherActions.length > 0 && (React.createElement(Styled.DialogActions, { otherActionCount: otherActions?.length },
            otherActionButtons,
            cancelButton,
            secondaryConfirmButton,
            confirmButton)),
        !(otherActions && otherActions.length > 0) && (React.createElement(Styled.DialogThreeButtonActions, { "$secondaryConfirmText": secondaryConfirmText },
            cancelButton,
            secondaryConfirmButton,
            confirmButton))));
};
StylovyzeDialog.defaultProps = {};
export default StylovyzeDialog;
